import { ProcessStepAssociationCoreBase } from "./process-step-association.core.base"


export class ProcessStepAssociationCore extends ProcessStepAssociationCoreBase {

}